"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @bit
 * @name datePicker
 * @description Used for configuring the Belle DatePicker component
 */

var datePickerConfig = {
  preventFocusStyleForTouchAndClick: true
};

exports.default = datePickerConfig;

//# sourceMappingURL=impl.js.map


// WEBPACK FOOTER //
// ./src/components/config/date-picker-config/belle.react-components/1/dist/impl.js